import { Card } from "../molecules/card";
import { Count } from "../atoms/count";

interface PageProps {
  title: string;
  titleNode?: React.ReactNode;
  description?: string;
  descriptionNode?: React.ReactNode;
  count?: number;
  card?: boolean;
  tabs?: React.ReactNode;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export const Page = ({
  title,
  titleNode,
  description,
  descriptionNode,
  count,
  card = true,
  tabs,
  actions,
  children,
}: PageProps) => {
  return (
    <>
      <div className="h-full flex flex-col space-y-3">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between">
          <div className="w-full md:w-auto flex flex-col space-y-1 md:space-y-1.5">
            <div className="flex flex-col sm:flex-row justify-between items-center">
              <div className="flex justify-start items-center">
                {titleNode && titleNode}
                {!titleNode && (
                  <h3 className="text-lg md:text-xl font-semibold text-dark md:text-secondary">
                    {title}
                  </h3>
                )}
                {count ? <Count count={count} /> : <></>}
              </div>
              {actions && (
                <div className="md:hidden flex justify-center items-center space-x-3 my-2 w-full">
                  {actions}
                </div>
              )}
            </div>
            {description && (
              <p className="max-sm:text-sm leading-6 text-gray-500 pb-3 text-center">
                {description}
              </p>
            )}
            {descriptionNode && descriptionNode}
          </div>
          {actions && (
            <div className="flex-1 hidden mb-4 md:mb-0 md:flex justify-end items-center space-x-3">
              {actions}
            </div>
          )}
        </div>
        {tabs && <div className="pb-2 md:pb-0">{tabs}</div>}
        {card ? <Card>{children}</Card> : children}
      </div>
    </>
  );
};
